<template>
  <q-input
    filled
    dense
    v-model="content"
    mask="time"
    :disabled="disabled"
    :rules="['time']"
  >
    <template v-slot:append>
      <q-icon name="access_time" class="cursor-pointer">
        <q-popup-proxy transition-show="scale" transition-hide="scale">
          <q-time v-model="content" format24h/>
        </q-popup-proxy>
      </q-icon>
    </template>
  </q-input>
</template>

<script>
export default {
  name: "STimePicker",
  props: {
    formatmm: { default: false, type: Boolean },
    value: { default: null },

    disabled: { default: false, type: Boolean },
  },
  data() {
    return {
      initialValue: null,
      content: null,
    };
  },
  created() {},
  watch: {
    content: function (val, oldval) {
      _log_("time mm", this.value, val, oldval);
      if (val != oldval && val != this.value) {
        if (this.formatmm !== false) {
          const prts = val.split(":");
          val = parseInt(prts[0]) * 60 + parseInt(prts[1]);
          if (val == this.value) return;
        }
        this.$emit("input", val);
        this.$emit("change", val);
      }
    },
    value: {
      handler(v, vo) {
        _log_("time mm", v);
        if (v != vo) {
          if (this.formatmm !== false) {
            v = v * 1;
            const hs = Math.floor(v / 60),
              mn = v % 60;
            v = (hs < 10 ? "0" + hs : hs) + ":" + (mn < 10 ? "0" + mn : mn);
          }
          this.content = v;
        }
      },
      immediate: true,
    },
  },
  methods: {},
};
</script>
<style>
.number-input {
  /* border-radius: 4px; */
  background-color: unset;
  border: none;
  border-bottom: 1px solid #409eff;
}
.q-field__marginal {
  height: auto !important;
}
</style>

